const social = {
  youtube: {
    title: 'YouTube',
    key: 'YT',
    subscribers: '34000',
    url: 'https://youtube.com/@AndrewFolts'
  }
}

export default social